import postRequest from '../../../../../postRequest';

/**
 * Calls prices endpoint to get products price.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postPrices(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/prices';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Prices')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postPrices;
